import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  MiniStressTypePDFDownloadResponse,
  ActionType,
  IMiniStressTypeDownloadPdfData,
} from "models/stressCheck/miniStressTypeDownloadPdf";
import { httpStatus } from "configs/httpStatus";
import { downloadMiniStressPdfRequest } from "services/stressCheck";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./miniStressDownloadPdfActions";

function* miniStressPdfDownloadSaga({
  payload,
}: {
  payload: IMiniStressTypeDownloadPdfData;
}) {
  try {
    const response: MiniStressTypePDFDownloadResponse = yield call(
      downloadMiniStressPdfRequest,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadMiniStressPDFWatcher() {
  yield takeLatest(
    ActionType.MINI_STRESS_TYPE_DOWNLOAD_PDF as any,
    miniStressPdfDownloadSaga
  );
}

export default [fork(onDownloadMiniStressPDFWatcher)];
